export const baseUrl = ""
export const SYMETRIC_SECRET_KEY_PROD =
  process.env.GATSBY_SYMETRIC_SECRET_KEY_PROD || ""
export const SYMETRIC_SECRET_KEY_DEV =
  process.env.GATSBY_SYMETRIC_SECRET_KEY_DEV || ""
export const endPoints = {
  //user
  getCSRF: "/auth/generate-csrf",
  login: "/login",
  //dashboard
  platformsList: `/admin/article/categories/list`,
  trendingArticles: `/admin/article/trending-articles`,
  searchArticles: `/admin/article/search-articles`,
  categorySpecificArticles: "/admin/article/list-published",
  possibleSolutionsForIssue: "/admin/article/global-search-articles",
  getArticle: "/admin/article/get-article",

  getPlatformChildren: `/admin/article/platform-categories/list`,
  auth: {
    verifyToken: "/admin/auth/veriy-generate-tokens",
  },

  getPlatformCategories: `/admin/article/platform-categories/list`,
  //Ai
  getAiHelp: "/admin/ai/help",
  sendFeedback: "/admin/ai/feedback",

  //tickets
  createTicketCode: "/admin/ticket/get-ticket-code",
  createPresignUrl: "/admin/ticket/generate-presigned-url",
  createTicket: "/admin/ticket/create-ticket",
  getIssueTypes: "/admin/ticket/get-issues-list",
  getPlatforms: "/admin/article/platforms/list",
  getTicketList: "/admin/ticket/list-tickets",
  getTicketDetails: "/admin/ticket/ticket-detail",
  ticketReply: "/admin/ticket/reply-ticket",
  reOpenTicket: "/admin/ticket/re-open-ticket",

  //Remote access
  getRemoveAccessRequest: "/admin/remote-access/get-user-request",
  changeRemoteAccessStatus: "/admin/remote-access/update-status?area=help",
  getRemoteLogs: "/admin/remote-access/get-user-activity-logs",
}

export const methods = {
  get: "get",
  post: "post",
  put: "put",
  patch: "patch",
  delete: "delete",
  updated: "update",
}
